import Toaster from '../lib/toaster';
import logger from './logger';

export default class errorHandler {
  static handleError = (err, config = {}) => {
    if (err.response) {
      const { status } = err.response;
      if (status === 422 || err.response.data?.errors) {
        if (config.onInvalid) {
          config.onInvalid(err);
        } else {
          Toaster.showToast({
            className: 'danger',
            title: window.I18n.t('common.error'),
            content: `<ul class="error-list"><li>${err.response.data.errors
              .map((error) => error.full_message)
              .join('</li><li>')}</li></ul>`,
            delay: 10000,
          });
        }
      } else {
        logger.error(err);
        if (status === 404 && config.onNotFound) {
          config.onNotFound(err);
        }

        if (status === 500 && config.onServerError) {
          config.onServerError(err);
        }

        if ((status === 502 || status === 504) && config.onTimeOut) {
          config.onTimeOut(err);
        }
      }
    }
  };
}
